import { render, staticRenderFns } from "./page-agv-consolidated-delivery.vue?vue&type=template&id=d91c8c52&scoped=true&lang=pug&"
import script from "./page-agv-consolidated-delivery.vue?vue&type=script&lang=js&"
export * from "./page-agv-consolidated-delivery.vue?vue&type=script&lang=js&"
import style0 from "./page-agv-consolidated-delivery.vue?vue&type=style&index=0&id=d91c8c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91c8c52",
  null
  
)

export default component.exports